import { useFormikContext } from 'formik'
import { createFormikHelpers } from 'helpers/formik'
import Input from 'ui/components/forms/Input/'
import Select from 'ui/components/forms/Select/'

export const ProjectBaseInfo = ({
  flowOptions,
  projectPropertiesOptions,
  passboltOptions,
  canEditProjectSettings = true,
}) => {
  const formik = useFormikContext()

  const { fieldMeta, fieldValue, fieldError, setFieldValue, getFieldProps } =
    createFormikHelpers(formik)

  return (
    <>
      <Input
        required={true}
        label="Название проекта"
        name="name"
        id="projectNameInput"
        placeholder="Введите название проекта"
        meta={fieldMeta('name')}
        style={{ marginBottom: 0 }}
        disabled={!canEditProjectSettings}
        {...getFieldProps('name')}
      />
      <Input
        required={true}
        label="Символьный код"
        placeholder="Введите символьный код"
        name="slug"
        eta={fieldMeta('slug')}
        style={{ marginBottom: 0 }}
        disabled={!canEditProjectSettings}
        {...getFieldProps('slug')}
      />
      <Select
        options={projectPropertiesOptions}
        value={fieldValue('project_properties')}
        meta={fieldMeta('project_properties')}
        error={fieldError('project_properties')}
        onChange={(newValue) => {
          setFieldValue('project_properties', newValue || '')
        }}
        required={true}
        label="Свойства проекта"
        id="projectProperties"
        defaultTitle="Любой"
        maxHeight="174px"
        placeholder="Свойства проекта"
        noMargin
        isDisabled={!canEditProjectSettings}
      />
      <Select
        options={passboltOptions}
        value={fieldValue('passbolt_folder')}
        meta={fieldMeta('passbolt_folder')}
        error={fieldError('passbolt_folder')}
        onChange={(newValue) => {
          setFieldValue('passbolt_folder', newValue || '')
        }}
        label="Папка passbolt"
        id="passboltSelect"
        defaultTitle="Любой"
        maxHeight="174px"
        placeholder="Не выбрана"
        noMargin
        isDisabled={!canEditProjectSettings}
      />
      <Select
        required={true}
        options={flowOptions}
        value={fieldValue('workflow')}
        meta={fieldMeta('workflow')}
        error={fieldError('workflow')}
        onChange={(newValue) => {
          setFieldValue('workflow', newValue || '')
        }}
        label="Workflow"
        id="workflowSelect"
        defaultTitle="Любой"
        maxHeight="174px"
        placeholder="Не выбран"
        noMargin
        isDisabled={!canEditProjectSettings}
      />
    </>
  )
}
